import { useLazyQuery } from '@apollo/client';
import { SearchOutlined } from '@material-ui/icons';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import DropDownSuggestions from 'component/drop-down-suggestions';
import config from 'config';
import { STYLE_SUGGESTION } from 'graph_ql/search/style_suggestion';
import React, { useEffect, useState } from 'react';
import themes from 'styles/themes';

export default function AutoCompleteSearch({
    handleKeyDown,
    value,
    setIsSearch,
    setValue,
    setDisable,
    isSearch,
    handleSearch,
    disable,
}) {
    const [suggestions, setSuggestions] = useState<Array<string>>([]);

    const [getSuggestions] = useLazyQuery(STYLE_SUGGESTION, {
        onCompleted(response) {
            const tempHits = [...response.locationsInRadius.hits];
            const tempSuggestions = tempHits.map((item) => item.query);
            setSuggestions(tempSuggestions);
        },
        onError(error) {
            console.error('get data Failed: ', error);
        },
    });

    const handleGetSugestions = (input) => {
        getSuggestions({
            variables: {
                index: config.algolia.algolia_prefix + 'styles_query_suggestions',
                query: input,
                filters: ``,
                facets: ['price', 'genders.value', 'categories.name'],
            },
        });
    };

    //handle
    const [displaySuggestion, setDisplaySuggestion] = useState(false);

    const handleOptionClick = async (suggestion) => {
        await setValue(suggestion);
        setTimeout(() => {
            handleKeyDown({ key: 'Enter' }, suggestion);
        }, 600);
    };

    const handleOnChangeSearch = async (event) => {
        setIsSearch(true);
        await setValue(event.target.value);
        if (value || event.target.value) {
            setDisplaySuggestion(true);
        }
    };

    const handleOnFocusSearch = (event) => {
        // console.log("e",event);
        if (event) {
            setDisplaySuggestion(true);
        }
    };

    const onCloseOption = () => {
        setTimeout(() => {
            setDisplaySuggestion(false);
        }, 500);
    };

    const handleOnKeyDown = (e) => {
        handleKeyDown(e, value);
        if (e.key === 'Enter') {
            setDisplaySuggestion(false);
            setDisable(true);
        }
    };

    useEffect(() => {
        handleGetSugestions(value);
        //eslint-disable-next-line
    }, [value]);
    return (
        <>
            <div
                style={{
                    position: 'relative',
                    display: 'flex',
                    flexDirection: 'column',
                    padding: '0',
                }}
            >
                <input
                    type="text"
                    placeholder="Search Your Style"
                    className="search-home"
                    style={{
                        background: 'rgba(255, 255, 255, 0.2)',
                        borderRadius: '29px ',
                        border: `1px solid ${themes.palette.primary.main}`,
                        backdropFilter: 'blur(8px)',
                        width: '100%',
                        padding: '9px 45px',
                        textAlign: 'center',
                        zIndex: 1,
                        caretColor: themes.palette.primary.main,
                    }}
                    disabled={disable}
                    onFocus={(e) => handleOnFocusSearch(e)}
                    onBlur={onCloseOption}
                    onKeyDown={(e) => handleOnKeyDown(e)}
                    value={value}
                    onChange={(e) => handleOnChangeSearch(e)}
                />
                <span style={{ position: 'absolute', left: 10, top: 8, zIndex: 2 }}>
                    <SearchOutlined style={{ color: themes.palette.primary.main }} />
                </span>
                {isSearch && value && (
                    <span
                        onClick={() => handleSearch(value)}
                        style={{
                            position: 'absolute',
                            right: 4,
                            top: 4,
                            background: '#fff',
                            borderRadius: 42,
                            width: 36,
                            height: 36,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            zIndex: 2,
                        }}
                    >
                        <ArrowForwardIcon style={{ color: 'black', width: 18 }} />
                    </span>
                )}
            </div>
            <DropDownSuggestions
                displaySuggestion={displaySuggestion}
                suggestions={suggestions}
                handleOptionClick={handleOptionClick}
            />
        </>
    );
}
